import { Link } from "react-router-dom"

function SidebarItemBlock({ icon, label, isActive = false, link, onClick }) {
    return (
      <Link to={link} className={`blocksidebar-item ${isActive ? 'active' : ''}`} onClick={onClick}>
        <span>{icon}</span>
        <span style={{fontSize: '13px'}}>{label}</span>
      </Link>
    )
  }
  
  export default SidebarItemBlock